import type { DefaultErrorProps } from '@grandvisionhq/www-next/pages/error'

export const defaultErrorProps: DefaultErrorProps = {
  title: 'Excuses voor het ongemak',
  subheader: 'De door jou opgevraagde pagina is niet beschikbaar.',
  buttonText: 'Home',
}
